export default {
    bind(el) {
        let startX = 0;
        let startY = 0;
        let initialLeft = 0;
        let initialTop = 0;
        let isDragging = false;
        let moved = false;
        const margin = 10;

        const getViewportWidth = () => window.innerWidth;
        const getViewportHeight = () => window.innerHeight;

        const maxLeft = () => getViewportWidth() - el.offsetWidth - margin;
        const maxTop = () => getViewportHeight() - el.offsetHeight - margin;

        const getCurrentPos = () => {
            const rect = el.getBoundingClientRect();
            return {
                left: rect.left,
                top: rect.top
            };
        };

        const onStart = (clientX, clientY) => {
            isDragging = true;
            moved = false;

            const pos = getCurrentPos();

            startX = clientX;
            startY = clientY;

            initialLeft = pos.left;
            initialTop = pos.top;

            el.style.transition = "none";
        };

        const onMove = (clientX, clientY) => {
            if (!isDragging) return;

            const deltaX = clientX - startX;
            const deltaY = clientY - startY;

            if (Math.abs(deltaX) > 5 || Math.abs(deltaY) > 5) {
                moved = true;
            }

            let newLeft = initialLeft + deltaX;
            let newTop = initialTop + deltaY;

            newLeft = Math.max(margin, Math.min(newLeft, maxLeft()));
            newTop = Math.max(margin, Math.min(newTop, maxTop()));

            el.style.left = newLeft + "px";
            el.style.top = newTop + "px";
        };

        const snapToRight = () => {
            el.style.transition = "left 0.25s ease";

            let targetLeft = maxLeft();

            el.style.left = targetLeft + "px";

            setTimeout(() => {
                el.style.transition = "";
            }, 300);

            isDragging = false;
        };

        // ---------- Mouse ----------
        const onMouseDown = (e) => {
            onStart(e.clientX, e.clientY);
            document.addEventListener("mousemove", onMouseMove);
            document.addEventListener("mouseup", onMouseUp);
        };
        const onMouseMove = (e) => onMove(e.clientX, e.clientY);
        const onMouseUp = () => {
            if (isDragging) snapToRight();
            document.removeEventListener("mousemove", onMouseMove);
            document.removeEventListener("mouseup", onMouseUp);
        };

        // ---------- Touch ----------
        const onTouchStart = (e) => {
            const t = e.touches[0];
            onStart(t.clientX, t.clientY);

            document.addEventListener("touchmove", onTouchMove, { passive: false });
            document.addEventListener("touchend", onTouchEnd);
        };
        const onTouchMove = (e) => {
            e.preventDefault();
            const t = e.touches[0];
            onMove(t.clientX, t.clientY);
        };
        const onTouchEnd = () => {
            snapToRight();
            document.removeEventListener("touchmove", onTouchMove);
            document.removeEventListener("touchend", onTouchEnd);
        };

        // ---------- SNAP ON WINDOW RESIZE ----------
        const onResize = () => {
            const pos = getCurrentPos();

            let newTop = pos.top;
            if (newTop > maxTop()) newTop = maxTop();
            if (newTop < margin) newTop = margin;

            el.style.top = newTop + "px";
            el.style.left = maxLeft() + "px";
        };

        window.addEventListener("resize", onResize);

        el._dragMoved = () => moved;

        el._dragHandlers = {
            onMouseDown,
            onTouchStart,
            onResize
        };

        el.addEventListener("mousedown", onMouseDown);
        el.addEventListener("touchstart", onTouchStart);
    },

    unbind(el) {
        if (el._dragHandlers) {
            el.removeEventListener("mousedown", el._dragHandlers.onMouseDown);
            el.removeEventListener("touchstart", el._dragHandlers.onTouchStart);
            window.removeEventListener("resize", el._dragHandlers.onResize);
        }
        delete el._dragHandlers;
        delete el._dragMoved;
    }
};
